<template>
  <v-container
    fluid
    grid-list-md
  >
    <v-layout row wrap>
      <v-flex xs12>
        <v-toolbar flat>
          <h2>Отчёт по столовым</h2>

          <div class="px-3"></div>

          <v-select
            :items="orgs"
            v-model="orgid"
            item-value="orgid"
            item-text="title"
            label="Организация"
            hide-details
            clearable
            class="mx-3"
            style="max-width: 300px"
            dense
          ></v-select>

          <v-menu offset-y bottom>
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-3"
                label="старт"
                v-model="start"
                v-on="on"
                :disabled="inAction"
                style="max-width: 120px"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="inAction" locale="ru" first-day-of-week="1"
              v-model="start" :landscape="true" :reactive="true"
            ></v-date-picker>
          </v-menu>

          <v-menu offset-y bottom>
            <template v-slot:activator="{ on }">
              <v-text-field
                class="mx-3"
                label="финиш"
                v-model="end"
                v-on="on"
                :disabled="inAction"
                style="max-width: 120px"
                hide-details
              ></v-text-field>
            </template>
            <v-date-picker
              :disabled="inAction" locale="ru" first-day-of-week="1"
              v-model="end" :landscape="true" :reactive="true"
            ></v-date-picker>
          </v-menu>

          <v-btn color="primary"
            @click="fetch()"
            :disabled="inAction || !orgid"
          >
            <template v-if="inAction">
              {{this.dayInAction}} &nbsp;
              <v-progress-circular :size="15" indeterminate></v-progress-circular>
            </template>
            <span v-else>Загрузить</span>
          </v-btn>

          <v-spacer></v-spacer>

          <v-btn @click="saveAs" :disabled="inAction || reportsalldays.length === 0"><v-icon>save</v-icon>Сохранить отчёт в файл csv</v-btn>

        </v-toolbar>
      </v-flex>

      <v-flex xs12>
        <v-card flat tile>
          <v-card-title>
            <v-subheader style="width: 114px">Итоги</v-subheader>
            <span class="body-2 weight-300" v-for="k in Object.keys(total)" :key="k">
              {{k}}: <b class="weight-500">{{rubles(total[k])}}</b>
              &nbsp;
            </span>
          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-card flat tile>
          <v-card-title>

            <v-subheader style="width: 100px">Просмотр</v-subheader>

            <v-select
              :items="groupbys"
              v-model="groupby"
              item-value="value"
              item-text="title"
              label="Группировать"
              hide-details
              clearable
              class="mx-3"
              style="max-width: 300px"
            ></v-select>

            <v-menu offset-y bottom>
              <template v-slot:activator="{ on }">
                <v-text-field
                  class="mx-3"
                  label="Показать один день из выборки"
                  v-model="day"
                  v-on="on"
                  :disabled="inAction || reports.length < 2"
                  style="max-width: 300px"
                  hide-details
                  clearable
                ></v-text-field>
              </template>
              <v-date-picker
                :disabled="inAction" locale="ru" first-day-of-week="1"
                v-model="day" :landscape="true" :reactive="true"
              ></v-date-picker>
            </v-menu>

            <v-spacer></v-spacer>

            <v-text-field
            label="поиск по фильтру"
            v-model="search"
            append-icon="search"
            style="max-width: 400px"
            outlined clearable hide-details flat
            ></v-text-field>

          </v-card-title>
        </v-card>
      </v-flex>

      <v-flex xs12>
        <v-data-table
          :headers="headers"
          :items="items"
          :search="search" :group-by.sync="groupby"
          class="elevation-0"
          no-data-text="пусто" no-results-text="ничего не найдено"
          :items-per-page="-1"
          dense flat hide-default-footer
        >
          <template v-slot:item.sum="{ item }">
            <span>{{ rubles(item.sum) }}</span>
          </template>
        </v-data-table>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import moment from 'moment'
const FileSaver = require('file-saver')

async function asyncTimeout (ms) {
  return new Promise((resolve, reject) => {
    setTimeout(() => resolve(), ms)
  })
}

export default {
  name: 'CafeReports',
  data: () => ({
    start: moment().startOf('month').format('YYYY-MM-DD'),
    end: moment().format('YYYY-MM-DD'),
    day: null,
    inAction: false,
    dayInAction: null,
    stopNext: false,
    reports: [],
    reportsalldays: [],
    search: null,
    orgs: [],
    orgid: null,
    saletypes: [],
    groupbys: [{
      title: 'Столовая',
      value: 'cafetitle'
    }, {
      title: 'Тип продажи',
      value: 'saletypetitle'
    }],
    groupby: 'cafetitle',
    headers: [
      { text: 'код столовой', value: 'cafeid', width: '240' },
      { text: 'столовая', value: 'cafetitle', width: '240' },
      { text: 'тип', width: '240', value: 'saletypetitle' },
      { text: 'сумма', width: '200', value: 'sum', },
    ],
  }),
  methods: {
    async fetch () {
      try {
        this.inAction = true
        this.totalBanks = 0
        this.reports = []
        this.dayInAction = 'Запуск'
        await asyncTimeout(500)
        if (moment(this.end).isBefore(moment(this.start))) {
          const e = new Error('Старт должен быть перед финишем')
          this.$store.dispatch('snack', e)
          throw e
        }
        this.reportsalldays = []
        await this.fetchReports()
      } catch (e) {
        this.$store.dispatch('snack', e)
        this.reportsalldays = []
      } finally {
        this.inAction = false
        this.dayInAction = null
      }
    },
    async fetchRequirements () {
      try {
        this.inAction = true
        
        const orgs = (await this.$store.dispatch('sioRequest', {
          topic: 'fetch-orgs',
        })).orgs
        this.orgs = orgs.filter(x => x.activities.map(y => y.activitytypeid).includes('cafe'))
        this.saletypes = (await this.$store.dispatch('sioRequest', {
          topic: 'fetch-saletypes',
        })).saletypes
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inAction = false
      }
    },
    addReport (report) {
      const sumReports = [
        ...(this.reportsalldays),
        ...report.map(x => Object.assign({}, x))
      ]
      // console.log(this.reportsalldays.length, report.length, sumReports.length)
      const reduced = sumReports.reduce((r, x) => {
        // console.log('x', JSON.stringify(x))
        const exists = (y) => x.cafeid === y.cafeid && x.cafetitle === y.cafetitle && x.saletypetitle === y.saletypetitle
        x.sum = parseInt(x.sum)
        const existing = r.find(exists)
        // console.log('exists', JSON.stringify(existing))
        if (existing) {
          existing.sum += x.sum
          // console.log('increased', JSON.stringify(existing))
          r = [...(r.filter(y => !exists(y))), existing]
        } else {
          // console.log('adding', JSON.stringify(x))
          r.push(x)
        }
        return r
      }, [])
      // console.log(reduced)
      this.reportsalldays = reduced
      return this.reportsalldays
    },
    async fetchReports () {
      for (let day = this.end; moment(this.start).isBefore(day) || this.start === day; day = moment(day).subtract(1, 'day').format('YYYY-MM-DD')) {
        if (this.stopNext === true) {
          const e = new Error('Остановлено пользователем')
          this.$store.dispatch('snack', e)
          throw e
        }
        this.dayInAction = day
        const report = await this.fetchReport(day)
        this.reports.push({ day, report })
        this.addReport(report)
      }
    },
    async fetchReport (day) {
      this.inAction = true
      const orgid = this.orgid
      try {
        const { report } = await this.$store.dispatch('sioRequest', {
          topic: 'fetch-org-report-by-cafes',
          pl: {
            day, orgid
          }
        })
        return report
      } catch (e) {
        this.$store.dispatch('snack', e)
      } finally {
        this.inAction = false
        this.stopNext = false
      }
    },
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    },
    drop () {
      this.reports = []
      this.reportsalldays = []
      this.day = null
    },
    getCSV () {
      return '"Название столовой";"Код столовой";"Вид реализации";"Сумма в рублях"\r\n' + this.reportsalldays.map(x => `"${x.cafetitle}";"${x.cafeid}";"${x.saletypetitle}";"${this.rubles(x.sum)}"\r\n`).join('')
    },
    saveAs () {
      const file = new File(
        [this.getCSV()],
        `report-${this.orgid}-${this.start}-${this.end}.csv`,
        { type: 'text/plain;charset=utf-8' }
      )
      FileSaver.saveAs(file)
    },
  },
  watch: {
    start () {
      this.drop()
    },
    end () {
      this.drop()
    },
    orgid () {
      this.drop()
    },
    async profile (val) {
      if (val) await this.fetchRequirements()
    }
  },
  computed: {
    profile () {
      return this.$store.state.profile
    },
    items () {
      if (this.day) {
        const exists = this.reports.find(x => x.day === this.day)
        return exists ? [...(exists.report)] : []
      } else {
        return [...(this.reportsalldays)]
      }
    },
    total () {
      // console.log('recalc')
      try {
        // console.log(this.items)
        const total = this.items.reduce((r, x) => {
          x.sum = parseInt(x.sum)
          if (r[x.saletypetitle]) {
            // console.log(r[x.saletypetitle])
            r[x.saletypetitle] += x.sum
            // console.log('+', x.sum, '=', r[x.saletypetitle])
          } else {
            r[x.saletypetitle] = x.sum
            // console.log('+', x.sum, '=', r[x.saletypetitle])
          }
          return r
        }, {})
        return total
      } catch (e) {
        console.log(e)
        throw e
      }
    }
  },
  async mounted () {
    if (this.profile) await this.fetchRequirements()
  }
}
</script>

<style lang="css">
</style>
